import faceshot from "../images/faceshot.webp";

export default function FaceShotBox() {
  return <img src={faceshot} className="hero-img" alt="Emirhan Karagöz" />;
}
